// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/locale-provider/style/index.less
// module id = 523
// module chunks = 0